import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import {
    ID_FILTER_REGISTRY_CARD_NUMBER,
    ID_FILTER_REGISTRY_CARD_STATUS,
    ID_FILTER_REGISTRY_CARD_USE,
    ID_FILTER_REGISTRY_DUE_DATE_FROM, ID_FILTER_REGISTRY_DUE_DATE_TO,
    ID_FILTER_REGISTRY_ID_MS_ASSIGNEE,
    ID_FILTER_REGISTRY_MS_ASSIGNEE,
    ID_FILTER_REGISTRY_PROVIDER,
    ID_FILTER_SEARCH,
    ID_FILTER_LEGAL_ENTITIES,
    ID_FILTER_DEALERS
} from "../../pages/cardfuel/constants/FuelFilters";
import dayjs from "dayjs";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useRegistryFuelCardsRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/finance/registryFuelCards";
    
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
    

    function getRegistryFuelCards(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let cardNumber = getFilterValue(ID_FILTER_REGISTRY_CARD_NUMBER, filterDefs);
        let provider = getFilterValue(ID_FILTER_REGISTRY_PROVIDER, filterDefs);
        let cardUse = getFilterValue(ID_FILTER_REGISTRY_CARD_USE, filterDefs);
        let idMsAssignee = getFilterValue(ID_FILTER_REGISTRY_ID_MS_ASSIGNEE, filterDefs);
        let msAssignee = getFilterValue(ID_FILTER_REGISTRY_MS_ASSIGNEE, filterDefs);
        let dueDateFrom: Date = getFilterValue(ID_FILTER_REGISTRY_DUE_DATE_FROM, filterDefs);
        let dueDateTo: Date = getFilterValue(ID_FILTER_REGISTRY_DUE_DATE_TO, filterDefs);
        let status = getFilterValue(ID_FILTER_REGISTRY_CARD_STATUS, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            cardNumber: cardNumber,
            provider: provider,
            cardUse: cardUse,
            idMsAssignee: idMsAssignee,
            msAssignee: msAssignee,
            dueDateFrom: dueDateFrom ? dayjs(dueDateFrom).toISOString() : null,
            dueDateTo: dueDateTo ? dayjs(dueDateTo).toISOString() : null,
            status: status,
            legalEntities,
            dealers
        }

        return GET(`${PATH}`,
            {
                params: params, paramsSerializer: (params) => qs.stringify(params,
                    {arrayFormat: 'repeat', skipNulls: true})
            });
    }

    function postRegistryCard(payload: any): Promise<HTTPGenericResponse> {

        return POST(`${PATH}`, payload, {}, true);
    }

    function updateRegistryFuelCard(payload: any): Promise<HTTPGenericResponse> {
        return PUT(`${PATH}/?id=`+payload.id, payload, {}, true);
    }

    function deleteRegistryFuelCard(id: string): Promise<HTTPGenericResponse> {
        return DELETE(`${PATH}/?id=` + id, {}, true);
    }


    return {
        postRegistryCard,
        getRegistryFuelCards,
        updateRegistryFuelCard,
        deleteRegistryFuelCard
    };
}